import apiClient from '../../api/index';
import {
  IStopSettingsService,
  SpecificCausesResponse
} from './contracts/stopSettings.service';

const StopSettingsService: IStopSettingsService = {
  async getSpecificCauses(): Promise<SpecificCausesResponse> {
    const response = await apiClient.request(
      'GET',
      '/stop-settings/specific-causes?eager=tags'
    );
    return response as SpecificCausesResponse;
  }
};

export default StopSettingsService;
